import { useEffect, useState } from "react";

const CLOCK_REFRESH_MS = 30000;

const currentTime = () =>
  new Date().toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });

/** Heure courante « HH:MM », rafraîchie toutes les 30 s. */
export function useClock(): string {
  const [time, setTime] = useState(currentTime());
  useEffect(() => {
    const handle = window.setInterval(() => setTime(currentTime()), CLOCK_REFRESH_MS);
    return () => window.clearInterval(handle);
  }, []);
  return time;
}

export default useClock;
